import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const NavBar = styled.nav`
  background: ${props => props.navbarColor};
  border-bottom: 3px solid var(--accent-color, #667eea);
  padding: max(8px, 10px) max(15px, 2vw);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
  position: sticky;
  top: 0;
  z-index: 100;
  transition: background-color 0.3s ease, border-color 0.3s ease;
  overflow: visible;
  @media (max-width: 768px) { padding: 10px 4px; }
`;

export const NavContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 50px;
  padding: 0 30px;
  background-color: ${props => props.$bgColor || 'transparent'};
  @media (max-width: 768px) {
    padding: 8px 4px;
    flex-wrap: wrap;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;
export const Tagline = styled.div`
  text-align: center;
  flex: 1;
  padding: 0 12px;

  @media (max-width: 768px) {
    order: 3;
    flex-basis: 100%;
    margin-top: 8px;
    padding: 4px 8px 0;
  }
`;

export const DrawerBackdrop = styled.div`
  display: ${p => p.active ? 'block' : 'none'};
  position: fixed;
  top: 70px;
  left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.45);
  z-index: 198;
`;

export const RightSection = styled.div`
  position: fixed;
  top: 70px;
  right: 0;
  height: calc(100vh - 70px);
  width: 260px;
  background: #111;
  border-left: 1px solid #2a2a2a;
  box-shadow: -4px 0 24px rgba(0,0,0,0.6);
  z-index: 199;
  display: flex;
  flex-direction: column;
  transform: ${p => p.active ? 'translateX(0)' : 'translateX(100%)'};
  transition: transform 0.25s ease;
  overflow-y: auto;
`;

export const Logo = styled(Link)`
  color: white;
  font-size: max(13px, 1.6vw);
  font-weight: 700;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: max(6px, 0.6vw);
  &:hover { opacity: 0.9; }
`;

export const NavLink = styled(Link)`
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.3s;
  padding: 10px 0;
  &:hover { color: #fff; text-decoration: underline; }

  @media (max-width: 768px) { width: 100%; padding: 15px 0; }
`;

export const NavButton = styled.button`
  background: ${props => props.variant === 'text' ? 'transparent' : props.accentColor};
  color: #fff;
  border: ${props => props.variant === 'text' ? 'none' : `2px solid ${props.accentColor}`};
  padding: ${props => props.variant === 'text' ? '10px 0' : '10px 20px'};
  border-radius: 5px;
  font-weight: ${props => props.variant === 'text' ? '500' : '600'};
  cursor: pointer;
  transition: all 0.3s;
  font-size: ${props => props.variant === 'text' ? '16px' : 'auto'};
  opacity: ${props => props.variant === 'text' ? '0.9' : '0.8'};

  &:hover {
    opacity: 1;
    transform: ${props => props.variant === 'text' ? 'none' : 'translateY(-2px)'};
    text-decoration: ${props => props.variant === 'text' ? 'underline' : 'none'};
    box-shadow: ${props => props.variant === 'text' ? 'none' : `0 2px 8px ${props.accentColor}`};
  }

  @media (max-width: 768px) {
    width: ${props => props.variant === 'text' ? '100%' : '80%'};
    margin: ${props => props.variant === 'text' ? '0' : '10px auto'};
    padding: ${props => props.variant === 'text' ? '15px 0' : '10px 20px'};
  }
`;

export const MenuButton = styled.button`
  background: var(--accent-color, #667eea);
  color: #fff;
  border: 2px solid var(--accent-color, #667eea);
  padding: 10px 20px;
  border-radius: 5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  width: 100%;
  margin: 10px 0;
  &:hover { opacity: 0.9; box-shadow: 0 2px 8px var(--accent-color, #667eea); }
`;

export const HamburgerMenu = styled.button`
  display: block;
  background: none;
  border: none;
  color: white;
  font-size: max(20px, 1.8vw);
  cursor: pointer;
`;

export const UserChip = styled.div`
  display: flex;
  align-items: center;
  gap: max(5px, 0.5vw);
  color: rgba(255,255,255,0.9);
  font-size: max(11px, 0.9vw);
  font-weight: 600;
`;

export const ChipAvatar = styled.img`
  width: max(20px, 1.8vw);
  height: max(20px, 1.8vw);
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.4);
  object-fit: cover;
`;

export const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  @media (max-width: 768px) { flex-direction: column; width: 100%; gap: 10px; }
`;

export const UserAvatar = styled.img`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid white;
`;

export const LogoutBtn = styled.button`
  background: #e74c3c;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s;
  &:hover { background: #c0392b; }
`;

export const MsgBtn = styled.button`
  position: relative;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  padding: 2px 0 2px 4px;
  line-height: 1;
  opacity: 0.85;
  flex-shrink: 0;
  &:hover { opacity: 1; }
`;

export const MsgBadge = styled.span`
  position: absolute;
  top: -4px;
  right: -6px;
  background: #e74c3c;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  pointer-events: none;
`;

export const DrawerSection = styled.div`
  padding: 16px 0 8px;
  & + & { border-top: 1px solid #1f1f1f; }
`;

export const DrawerLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: rgba(255,255,255,0.3);
  padding: 0 20px 8px;
  text-transform: uppercase;
`;

export const DrawerItem = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  margin: 2px 8px;
  border-radius: 8px;
  color: ${p => p.active ? '#fff' : 'rgba(255,255,255,0.7)'};
  background: ${p => p.active ? p.accent + '33' : 'transparent'};
  text-decoration: none;
  font-size: 14px;
  font-weight: ${p => p.active ? '600' : '500'};
  transition: background 0.15s, color 0.15s;
  &:hover { background: ${p => p.active ? p.accent + '44' : 'rgba(255,255,255,0.07)'}; color: #fff; }
`;

export const DrawerBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  margin: 2px 8px;
  width: calc(100% - 16px);
  border-radius: 8px;
  background: ${p => p.active ? p.accent + '33' : 'transparent'};
  border: none;
  color: ${p => p.active ? '#fff' : 'rgba(255,255,255,0.7)'};
  font-size: 14px;
  font-weight: ${p => p.active ? '600' : '500'};
  cursor: pointer;
  text-align: left;
  transition: background 0.15s, color 0.15s;
  &:hover { background: rgba(255,255,255,0.07); color: #fff; }
`;

export const DrawerBadge = styled.span`
  margin-left: auto;
  background: ${p => p.accent};
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
`;

export const DrawerFooter = styled.div`
  margin-top: auto;
  padding: 16px 12px;
  border-top: 1px solid #1f1f1f;
`;

export const DrawerLogout = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  background: transparent;
  border: none;
  color: #e74c3c;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 10px 8px;
  border-radius: 8px;
  transition: background 0.15s;
  &:hover { background: rgba(231,76,60,0.12); }
`;
